import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["lang"]

import { computed, ref, onMounted, onUnmounted, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import TooltipStandardV2 from './TooltipStandardV2.vue'

export type TextType = 'display' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'paragraph' | 'label' | 'tiny'

export type TextWeight = 'regular' | 'bold'

export type TextColor = 'primary' | 'secondary' | string

export type TextOverflow = 'ellipsis' | 'break-word'

export type TextWrap = 'nowrap' | 'wrap'

export type Props = {
  type?: TextType
  overflow?: TextOverflow
  weight?: TextWeight
  underline?: boolean
  color?: TextColor
  disabled?: boolean
  text?: string
  textWrap?: TextWrap
  overflowTooltip?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextBase',
  props: {
    type: { default: 'paragraph' },
    overflow: { default: 'break-word' },
    weight: { default: 'regular' },
    underline: { type: Boolean, default: false },
    color: { default: 'primary' },
    disabled: { type: Boolean, default: false },
    text: { default: '-' },
    textWrap: { default: 'wrap' },
    overflowTooltip: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const { locale } = useI18n()

const textRef = ref<HTMLElement>()

const overflowing = ref<boolean>(false)

const styles = computed<object>((): object => ({
  ...(props.overflow === 'ellipsis'
    ? {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textWrap: 'nowrap',
        whiteSpace: 'nowrap',
        width: '100%'
      }
    : {}),
  textWrap: props.textWrap
}))

const update = () => {
  if (textRef.value) {
    const textElement = textRef.value
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ = textElement.offsetWidth // reading offsetWidth can help flush style changes
    overflowing.value = textElement.scrollWidth > textElement.clientWidth
  }
}

let ro: ResizeObserver | null = null
onMounted((): void => {
  if (props.overflow === 'ellipsis' && textRef.value) {
    ro = new ResizeObserver((): void => {
      update()
    })
    ro.observe(textRef.value)
  }
})

onUnmounted((): void => {
  if (ro && textRef.value) {
    ro.unobserve(textRef.value)
    ro.disconnect()
    ro = null
  }
})

watchEffect(() => update())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TooltipStandardV2, {
    "disabled-tooltip": !(overflowing.value && props.overflowTooltip),
    text: _ctx.text,
    "arrow-position": "top-center",
    "position-absolute": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        ref_key: "textRef",
        ref: textRef,
        lang: _unref(locale),
        class: _normalizeClass([
        'text',
        {
          text__display: _ctx.type === 'display',
          text__h1: _ctx.type === 'h1',
          text__h2: _ctx.type === 'h2',
          text__h3: _ctx.type === 'h3',
          text__h4: _ctx.type === 'h4',
          text__h5: _ctx.type === 'h5',
          text__paragraph: _ctx.type === 'paragraph',
          text__label: _ctx.type === 'label',
          text__tiny: _ctx.type === 'tiny',
          text__bold: _ctx.weight === 'bold',
          text__color_secondary: _ctx.color === 'secondary',
          text__underline: _ctx.underline,
          text__disabled: _ctx.disabled
        }
      ]),
        style: _normalizeStyle({ ...(_ctx.color !== 'primary' && _ctx.color !== 'secondary' ? { color: _ctx.color } : {}), ...styles.value })
      }, _toDisplayString(_ctx.text), 15, _hoisted_1)
    ]),
    _: 1
  }, 8, ["disabled-tooltip", "text"]))
}
}

})